import React, { createContext, useState, ReactNode } from "react";

interface ApiContextType {
  logindata: any;
  setlogindata: React.Dispatch<React.SetStateAction<any>>;

  userData: any;
  setuserData: React.Dispatch<React.SetStateAction<any>>;

  coordinates: any;
  setcoordinates: React.Dispatch<React.SetStateAction<any>>;

  address: string;
  setaddress: React.Dispatch<React.SetStateAction<string>>;

  SODBody: any;
  setSODBody: React.Dispatch<React.SetStateAction<any>>;
}

export const ApiContext = createContext<ApiContextType | undefined>(undefined);

interface ContextProps {
  children: ReactNode;
}

export const Context = ({ children }: ContextProps) => {
  const [logindata, setlogindata] = useState<any>({});
  const [userData, setuserData] = useState<any>({});
  const [coordinates, setcoordinates] = useState<any>(null);
  const [address, setaddress] = useState<string>("");
    const [SODBody, setSODBody] = useState<any>(null);

  return (
    <ApiContext.Provider
      value={{
        logindata,
        setlogindata,
        coordinates,
        setcoordinates,
        address,
        setaddress,
        userData,
        setuserData,SODBody,setSODBody
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};
